"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryPreviewIcon = exports.OpenPreviewButton = exports.MediaGalleryPreviewModal = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.MediaGalleryPreviewModal = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    name: 'galleryPreview',
    fullScreen: true,
})(({ theme }) => theme.mediaGallery.mediaGalleryModal);
exports.OpenPreviewButton = styled_components_1.default.button((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    bottom: 0,
    right: 0,
    mr: 0,
    variant: 'buttons.iconBtn',
    backgroundColor: 'transparent',
    '&:hover, &:focus': {
        backgroundColor: 'transparent',
        svg: {
            fill: 'transparent',
        },
    },
    zIndex: 1,
    '.icon': {
        color: 'white',
        fill: 'transparent',
        width: ['40px', '50px'],
        height: ['40px', '50px'],
    },
}));
exports.GalleryPreviewIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon).attrs({
    className: 'preview-icon',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: ['icons.md', `icons.lg`],
    filter: 'drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.7))',
}));
//# sourceMappingURL=bs-rsv-gallery.styles.js.map